import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            内容分类
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            按类别浏览您感兴趣的乳色吐息动漫内容，从剧情到角色，从观看指南到深度评测
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl aspect-[4/3] cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.name}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                    <i className={`${cat.icon} text-white text-base`}></i>
                  </span>
                </div>
                <h3 className="text-lg font-heading font-bold text-white mb-1">{cat.name}</h3>
                <p className="text-xs text-white/70 line-clamp-2">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}